module.exports = __webpack_public_path__ + "static/media/concept-r-en.d2015c22.png";